/**
 * Minimal event store for Concord V2.
 * Uses an in-memory map since the game platform doesn't need persistence
 * across sessions for the community list cache.
 */

import type { NostrEvent } from "@nostrify/types";

let _store: Map<string, NostrEvent[]> | null = null;

function getStore(): Map<string, NostrEvent[]> {
  if (!_store) _store = new Map();
  return _store;
}

class MinimalEventStore {
  async query(filters: Array<{ kinds?: number[]; authors?: string[]; [key: string]: unknown }>): Promise<NostrEvent[]> {
    const store = getStore();
    const results: NostrEvent[] = [];

    for (const events of store.values()) {
      for (const event of events) {
        for (const filter of filters) {
          if (this.matchesFilter(event, filter)) {
            results.push(event);
            break;
          }
        }
      }
    }

    // Sort by created_at descending (newest first)
    results.sort((a, b) => b.created_at - a.created_at);
    return results;
  }

  private matchesFilter(event: NostrEvent, filter: Record<string, unknown>): boolean {
    if (filter.kinds && Array.isArray(filter.kinds) && !filter.kinds.includes(event.kind)) {
      return false;
    }
    if (filter.authors && Array.isArray(filter.authors) && !filter.authors.includes(event.pubkey)) {
      return false;
    }
    return true;
  }
}

/** Return a minimal event store (lazy singleton) */
export function useEventStore(): Promise<MinimalEventStore> {
  return Promise.resolve(new MinimalEventStore());
}